import ForceChangePassword from './ForceChangePasswordContainer'

export default ForceChangePassword
